<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      consulta: null,
      now: new Date(),

      cancel: {
        modal: false,
        loading: false,
      }
    };
  },
  methods: {
    getConsulta() {
      this.consulta = null;

      api
        .get('telemedicina/consultas/' + this.$route.params.id)
        .then((response) => {
          if (response.data.status == 'success') {
            this.consulta = response.data.consulta;

            if (this.consulta && this.consulta.status == 'created') {
              setInterval(() => {
                this.now = new Date();
              }, 1000);
            }
          } else {
            this.$router.push("/telemedicina/consultas");
          }
        })
        .catch(error => {
          if (error) {
            this.$router.push("/telemedicina/consultas");
          }
        })
    },
    showCancelar() {
      this.cancel.modal = false;
      this.cancel.modal = true;
    },
    cancelarConsulta() {
      this.cancel.loading = true;

      api
        .post('telemedicina/consultas/' + this.$route.params.id + '/cancel')
        .then((response) => {
          if (response.data.status == 'success') {
            this.getConsulta();

            this.cancel.loading = false;
            this.cancel.modal = false;

            this.$toast.success(response.data.message);
          } else {
            this.cancel.loading = false;

            this.$toast.error(response.data.message);
          }
        })
        .catch(error => {
          if (error) {
            this.cancel.loading = false;
            this.cancel.modal = false;
            this.getConsulta();
          }
        })
    }
  },
  mounted() {
    this.getConsulta();
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/telemedicina">Telemedicina</router-link></li>
    </ol>

    <div v-if="!consulta" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>

    <div v-else>
      <div class="page-title-box d-md-flex justify-content-between mb-3">
        <div>
          <h3>{{ consulta.professional.specialty }}</h3>
          <p>{{ consulta.schedule.date }} às {{ consulta.schedule.hour }}</p>
        </div>
      </div>

      <div class="card card-icon mb-2">
        <div class="card-body d-flex align-items-center">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
              <path d="M15 2.013H9V9H2v6h7v6.987h6V15h7V9h-7z"></path>
            </svg>
          </div>
          <div class="ml-3 w-75 pt-1">
            <h5 class="m-0 text-dark font-size-16"><strong>{{ consulta.professional.name }}</strong></h5>
            <p class="m-0 text-dark text-uppercase">{{ consulta.professional.class }} – {{ consulta.professional.region }} {{ consulta.professional.register }}</p>
          </div>
        </div>
      </div>

      <div class="card card-icon mb-2">
        <div class="card-body d-flex align-items-center">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
              <path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.002 16H5V8h14l.002 12z"></path>
              <path d="m11 17.414 5.707-5.707-1.414-1.414L11 14.586l-2.293-2.293-1.414 1.414z"></path>
            </svg>
          </div>
          <div class="ml-3 w-75 pt-1">
            <h5 class="m-0 text-dark font-size-16"><strong>{{ consulta.schedule.date }}</strong></h5>
            <p class="m-0 text-dark font-size-13 text-uppercase">{{ consulta.schedule.week }}</p>
          </div>
        </div>
      </div>

      <div class="card card-icon">
        <div class="card-body d-flex align-items-center">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
              <path
                d="m20.145 8.27 1.563-1.563-1.414-1.414L18.586 7c-1.05-.63-2.274-1-3.586-1-3.859 0-7 3.14-7 7s3.141 7 7 7 7-3.14 7-7a6.966 6.966 0 0 0-1.855-4.73zM15 18c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z">
              </path>
              <path d="M14 10h2v4h-2zm-1-7h4v2h-4zM3 8h4v2H3zm0 8h4v2H3zm-1-4h3.99v2H2z"></path>
            </svg>
          </div>
          <div class="ml-3 w-75 pt-1">
            <h5 class="m-0 text-dark font-size-16"><strong>{{ consulta.schedule.hour }}</strong></h5>
          </div>
        </div>
      </div>

      <div class="card card-icon">
        <div class="card-body">
          <template v-if="consulta.schedule.liberation && new Date(consulta.schedule.liberation) <= this.now">
            <a class="btn btn-default btn-lg btn-block py-2 d-flex justify-content-center align-items-center" :href="consulta.appointment.link" :disabled="!consulta.appointment.status">
              <div class="py-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                  <path d="M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7zm-1.998 10H4V7h12l.001 4.999L16 12l.001.001.001 4.999z">
                  </path>
                </svg>
              </div>
              <div class="ml-2">
                Iniciar Consulta
              </div>
            </a>
            <div class="mt-2 text-center font-size-12">O acesso para sua consulta já está liberado.</div>
          </template>
          <template v-else>
            <a class="btn btn-default btn-lg btn-block py-2 d-flex justify-content-center align-items-center disabled">
              <div class="py-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                  <path d="M18 7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-3.333L22 17V7l-4 3.333V7zm-1.998 10H4V7h12l.001 4.999L16 12l.001.001.001 4.999z">
                  </path>
                </svg>
              </div>
              <div class="ml-2">
                Iniciar Consulta
              </div>
            </a>
            <div class="mt-2 text-center font-size-12">O acesso para sua consulta estará liberado 10 minutos antes do horário agendamento.</div>
          </template>
        </div>
      </div>

      <div v-if="consulta.status == 'created' && consulta.cancelable == 'yes'" class="mt-4 text-center">
        <button class="btn btn-outline-danger btn-block" v-on:click="showCancelar();">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
            <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
          </svg>
          Cancelar Consulta
        </button>
      </div>
    </div>

    <b-modal v-model="cancel.modal" modal-class="modal-bottom" hide-header hide-footer>
      <div>
        <h5 class="mb-4">Deseja confirmar o cancelamento da consulta?</h5>
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-default mr-3" v-on:click="cancelarConsulta()" :disabled="this.cancel.loading">
            Confirmar
            <b-spinner v-if="cancel.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <a class="btn btn-outline-link" v-on:click="cancel.modal = false">Fechar</a>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>